import { FormattedMessage, useMelioIntl } from '@melio/ar-domain';
import { Group, Illustration, Text } from '@melio/penny';
import { Payment } from '@melio/platform-api';
import { forwardRef } from '@melio/platform-utils';

import { GuestPaymentSuccessLayout } from '../../../layout';

export type PaymentScheduledScreenProps = {
  payment?: Payment;
  isLoading?: boolean;
  onBack?: VoidFunction;
  onDone?: VoidFunction;
};

export const PaymentScheduledScreen = forwardRef<PaymentScheduledScreenProps>(({ payment, isLoading }, ref) => {
  const { formatDate, formatCurrency, formatMessage } = useMelioIntl();
  return (
    <GuestPaymentSuccessLayout isLoading={isLoading} ref={ref} data-component="PaymentScheduledScreen">
      {payment ? (
        <Group variant="vertical" alignItems="center" textAlign="center" spacing="m">
          <Illustration size="small" type="success" />
          <Text textStyle="heading3Semi" as="h3">
            <FormattedMessage id="ar.guestPayment.activities.invoiceTable.toasts.download.processing.label" />
          </Text>
          <Text>
            {formatMessage('ar.guestPayment.activities.paymentScheduled.description.success.text', {
              formattedCurrency: formatCurrency(payment.amount),
              vendorName: payment.vendor?.name,
              formattedDate: formatDate(payment.scheduledDate),
            })}
          </Text>
        </Group>
      ) : (
        <Text textStyle="heading3Semi" as="h3">
          <FormattedMessage id="ar.guestPayment.activities.paymentScheduled.description.failure.text" />
        </Text>
      )}
    </GuestPaymentSuccessLayout>
  );
});
PaymentScheduledScreen.displayName = 'PaymentScheduledScreen';
